<template>
  <div :style="indent" >
    <template v-if="isMethodGroup">
      <fieldset>
        <div v-for="(field, index) in method" :key="'verification-field-' + depth.toString() + '-' + index.toString()">
          <div v-if="index > 0 && !hasAnyFieldValue" class="field-or-separator">
            <hr />
            <span>or</span>
          </div>
          <VerificationField v-if="showMethod(field)" :method="field" :value="fields" :placeholders="placeholders"></VerificationField>
        </div>
      </fieldset>
    </template>
    <fieldset v-else>
      <div class="fields mt-0 mob-verfi">
        <div v-if="isFirstName" class="pt-0 first-name">
          <div class="customer-match-formgroup">
            <label for="first_name" class="text-capitalize">First Name</label>
            <b-form-group label-for="first_name">
              <div data-for="first_name" class="placeholder-label">First Name</div>
              <b-form-input id="first_name" type="text" :value="fields.first_name"
                            :placeholder="placeholders.first_name" @input="updateData('first_name', $event)"
                            class="customer form-input-height" :required="isFieldRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-if="isLastName" class="pt-0 second-name">
          <div class="customer-match-formgroup">
            <label for="last_name" class="text-capitalize">Last Name</label>
            <span class="help-icon" tabindex="0" @focus="onHelpFocus" @blur="onHelpBlur">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M7.11708 4.44098C7.1119 4.26515 7.15936 4.09178 7.25336 3.94311C7.34736 3.79443 7.48363 3.67721 7.64469 3.60649C7.80575 3.53577 7.98426 3.51477 8.15733 3.54617C8.33041 3.57757 8.49017 3.65995 8.61611 3.78275C8.74206 3.90554 8.82846 4.06316 8.86424 4.23538C8.90002 4.40761 8.88354 4.58659 8.81693 4.74939C8.75031 4.91219 8.63659 5.05138 8.49034 5.14912C8.34409 5.24686 8.17198 5.2987 7.99608 5.29798C7.88174 5.30077 7.76799 5.28068 7.66152 5.23888C7.55505 5.19708 7.45802 5.13442 7.37612 5.05457C7.29422 4.97472 7.22912 4.87931 7.18463 4.77393C7.14015 4.66856 7.11718 4.55535 7.11708 4.44098ZM7.17708 5.97098H8.81408V12.147H7.17708V5.97098Z" fill="#AFBAC1"/>
                <path d="M8 1.077C9.60069 1.07854 11.1513 1.63494 12.3878 2.65143C13.6243 3.66793 14.4702 5.08165 14.7814 6.65179C15.0925 8.22194 14.8497 9.8514 14.0943 11.2626C13.339 12.6739 12.1177 13.7796 10.6386 14.3915C9.15947 15.0033 7.51397 15.0835 5.98237 14.6183C4.45077 14.1532 3.12779 13.1714 2.23878 11.8403C1.34977 10.5092 0.949712 8.91108 1.10675 7.31812C1.26378 5.72515 1.96819 4.2359 3.1 3.104C3.74196 2.45866 4.50564 1.94718 5.34678 1.59922C6.18791 1.25127 7.08975 1.07376 8 1.077ZM8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346625 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0Z" fill="#AFBAC1"/>
              </svg>
              <div class="help-popup" v-if="showHelp">{{getHelpText('last_name')}}</div>
            </span>
            <div class="help-popup-mobile" v-if="showHelp">{{getHelpText('last_name')}}</div>
            <b-form-group label-for="last_name">
              <div data-for="last_name" class="placeholder-label">Last Name</div>
              <b-form-input id="last_name" type="text" :value="fields.last_name" :placeholder="placeholders.last_name"
                            @input="updateData('last_name', $event)" class="customer form-input-height"
                            :required="isFieldRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-if="isFullAddress">
          <div class="customer-match-formgroup">
            <label for="address" class="text-capitalize">Address</label>
            <b-form-group label-for="address">
              <div data-for="address" class="placeholder-label">Address</div>
              <b-form-input id="address" type="text" :value="fields.address" :placeholder="placeholders.address"
                            @input="updateData('address', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
            <label for="city" class="text-capitalize mt-1">City</label>
            <b-form-group label-for="city">
              <div data-for="city" class="placeholder-label">City</div>
              <b-form-input id="city" type="text" :value="fields.city" :placeholder="placeholders.city"
                            @input="updateData('city', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
            <label for="country" class="text-capitalize mt-1">Country</label>
            <b-form-group label="" label-for="country">
              <div data-for="country" class="placeholder-label">Country</div>
              <b-form-select id="country" v-model="fields.country" :options="countries" placeholder="Country" @change="updateData('country', $event)" class="customer select"></b-form-select>
            </b-form-group>
            <label for="state" class="text-capitalize mt-1">State</label>
            <b-form-group label-for="state">
              <div data-for="state" class="placeholder-label">State</div>
              <b-form-select v-if="isUsOrCA()" id="state" v-model="fields.state" :options="getStates()"
                             :placeholder="placeholders.state" @input="updateData('state', $event)"
                             class="customer select form-input-height"></b-form-select>
              <b-form-input v-if="!isUsOrCA()" id="state" type="text" :value="fields.state" :placeholder="placeholders.state"
                            @input="updateData('state', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
            <label for="zip" class="text-capitalize mt-1">Zip</label>
            <b-form-group label-for="zip">
              <div data-for="zip" class="placeholder-label">Zip</div>
              <b-form-input id="zip" type="text" :formatter="zipFormat" :value="fields.zip" :placeholder="placeholders.zip"
                            @input="updateData('zip', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <template v-else>
          <div v-if="isStreet">
            <div class="customer-match-formgroup">
              <label for="address" class="text-capitalize">Address</label>
              <b-form-group label-for="address">
                <div data-for="address" class="placeholder-label">Address</div>
                <b-form-input id="address" type="text" :title="getStreetTitle" :value="fields.address"
                              :placeholder="placeholders.address" @input="updateData('address', $event)"
                              class="customer form-input-height" :required="isFieldRequired"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div v-if="isZip">
            <div class="customer-match-formgroup">
              <label for="zip" class="text-capitalize">Zip</label>
              <span class="help-icon" tabindex="0" @focus="onHelpFocus" @blur="onHelpBlur">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M7.11708 4.44098C7.1119 4.26515 7.15936 4.09178 7.25336 3.94311C7.34736 3.79443 7.48363 3.67721 7.64469 3.60649C7.80575 3.53577 7.98426 3.51477 8.15733 3.54617C8.33041 3.57757 8.49017 3.65995 8.61611 3.78275C8.74206 3.90554 8.82846 4.06316 8.86424 4.23538C8.90002 4.40761 8.88354 4.58659 8.81693 4.74939C8.75031 4.91219 8.63659 5.05138 8.49034 5.14912C8.34409 5.24686 8.17198 5.2987 7.99608 5.29798C7.88174 5.30077 7.76799 5.28068 7.66152 5.23888C7.55505 5.19708 7.45802 5.13442 7.37612 5.05457C7.29422 4.97472 7.22912 4.87931 7.18463 4.77393C7.14015 4.66856 7.11718 4.55535 7.11708 4.44098ZM7.17708 5.97098H8.81408V12.147H7.17708V5.97098Z" fill="#AFBAC1"/>
                <path d="M8 1.077C9.60069 1.07854 11.1513 1.63494 12.3878 2.65143C13.6243 3.66793 14.4702 5.08165 14.7814 6.65179C15.0925 8.22194 14.8497 9.8514 14.0943 11.2626C13.339 12.6739 12.1177 13.7796 10.6386 14.3915C9.15947 15.0033 7.51397 15.0835 5.98237 14.6183C4.45077 14.1532 3.12779 13.1714 2.23878 11.8403C1.34977 10.5092 0.949712 8.91108 1.10675 7.31812C1.26378 5.72515 1.96819 4.2359 3.1 3.104C3.74196 2.45866 4.50564 1.94718 5.34678 1.59922C6.18791 1.25127 7.08975 1.07376 8 1.077ZM8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346625 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0Z" fill="#AFBAC1"/>
              </svg>
                <div class="help-popup" v-if="showHelp">{{getHelpText('zip')}}</div>
            </span>
              <div class="help-popup-mobile" v-if="showHelp">{{getHelpText('zip')}}</div>
              <b-form-group label-for="zip">
                <div data-for="zip" class="placeholder-label">Zip</div>
                <b-form-input id="zip" type="text" :title="getZipTitle" :value="fields.zip"
                              :placeholder="placeholders.zip" @input="updateData('zip', $event)"
                              class="customer form-input-height" :required="isFieldRequired"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </template>
        <div v-if="isEmail">
          <div class="customer-match-formgroup">
            <label for="email" class="text-capitalize">Email</label>
            <b-form-group label-for="email">
              <div data-for="email" class="placeholder-label">Email</div>
              <b-form-input id="email" type="email" :value="fields.email" placeholder="example@gmail.com"
                            @input="updateData('email', $event)" class="customer form-input-height"
              :required="isFieldRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-if="isPhone">
          <div class="customer-match-formgroup">
            <label for="phone" class="text-capitalize">Phone Number</label>
            <b-form-group label-for="phone">
              <div data-for="phone" class="placeholder-label">Phone</div>
              <b-form-input id="phone" type="tel" :value="fields.phone" placeholder="555-555-5555"
                            @input="updateData('phone', $event)" class="customer form-input-height"
              :required="isFieldRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {formatZipField, getCountryStates, isCountryUSOrCA, getCountries} from '@/utils'
import {VerificationFieldsHelpText} from '@/constants'

const VerificationMethod = Object.freeze({
  FullName: 1,
  LastName: 2,
  Street: 3,
  Zip: 4,
  Address: 5,
  BillingStreet: 6,
  BillingZip: 7,
  BillingAddress: 8,
  Phone: 1000,
  PartialPhone: 1001,
  Email: 1002,
  PartialEmail: 1003
})

const VerificationMethodFields = Object.freeze({
  [VerificationMethod.FullName]: ['first_name', 'last_name'],
  [VerificationMethod.LastName]: ['last_name'],
  [VerificationMethod.Street]: ['address'],
  [VerificationMethod.Zip]: ['zip'],
  [VerificationMethod.Address]: ['address', 'city', 'state', 'zip', 'country'],
  [VerificationMethod.BillingStreet]: ['address'],
  [VerificationMethod.BillingZip]: ['zip'],
  [VerificationMethod.BillingAddress]: ['address', 'city', 'state', 'zip', 'country'],
  [VerificationMethod.Phone]: ['phone'],
  [VerificationMethod.PartialPhone]: ['phone'],
  [VerificationMethod.Email]: ['email'],
  [VerificationMethod.PartialEmail]: ['email']
})

export default {
  name: 'VerificationField',
  props: {
    method: [Number, Array],
    depth: {
      type: Number,
      default: function() {
        return 0
      }
    },
    allFieldsRequired: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    value: {
      type: Object,
      default: function() {
        return {
          first_name: null,
          last_name: null,
          address: null,
          city: null,
          state: null,
          zip: null,
          phone: null,
          email: null,
          country: 'US'
        }
      }
    },
    placeholders: Object
  },
  data: function() {
    return {
      fields: Object.assign({}, this.value),
      showHelp: false
    }
  },
  computed: {
    ...mapState(['isIE', 'campaign', 'session']),
    countries() {
      return [{value: null, text: 'Country'}, ...getCountries(this.session)]
    },
    isMethodGroup: function() {
      return this.method && typeof this.method === 'object'
    },
    isFirstName: function() {
      return this.method === VerificationMethod.FullName
    },
    isLastName: function() {
      return this.method === VerificationMethod.LastName || this.method === VerificationMethod.FullName
    },
    isStreet: function() {
      return this.method === VerificationMethod.BillingStreet || this.method === VerificationMethod.BillingAddress ||
        this.method === VerificationMethod.Street || this.method === VerificationMethod.Address
    },
    isFullAddress: function() {
      return this.method === VerificationMethod.BillingAddress || this.method === VerificationMethod.Address
    },
    isZip: function() {
      return this.method === VerificationMethod.BillingZip || this.method === VerificationMethod.BillingAddress ||
        this.method === VerificationMethod.Zip || this.method === VerificationMethod.Address
    },
    isBilling: function() {
      return this.method === VerificationMethod.BillingZip || this.method === VerificationMethod.BillingAddress ||
        this.method === VerificationMethod.BillingStreet
    },
    isEmail: function() {
      return this.method === VerificationMethod.Email || this.method === VerificationMethod.PartialEmail
    },
    isPhone: function() {
      return this.method === VerificationMethod.Phone || this.method === VerificationMethod.PartialPhone
    },
    getStreetLabel: function() {
      return this.isBilling ? 'Billing Street:' : 'Street:'
    },
    getStreetTitle: function() {
      return this.isBilling ? 'House number and street of your billing address'
        : 'House number and street of either your billing or shipping address'
    },
    getZipLabel: function() {
      return this.isBilling ? 'Billing Zip/Postal Code:' : 'Zip/Postal Code:'
    },
    getZipTitle: function() {
      return this.isBilling ? 'Zip/Postal code of your billing address'
        : 'Zip/Postal code of either your billing or shipping address'
    },
    indent: function() {
      return { transform: `translate(${this.depth * 50}px)` }
    },
    isFieldRequired: function() {
      return this.allFieldsRequired ||
        (Object.values(this.fields).every(v => !v) && Object.values(this.value).every(v => !v))
    },
    hasAnyFieldValue: function() {
      return Object.values(this.fields).some(v => v)
    }
  },
  methods: {
    hasFieldValue: function(method) {
      if (typeof method === 'object') {
        return Object.values(method).some(m => this.hasFieldValue(m))
      }
      const fields = VerificationMethodFields[method] || []
      for (const field of fields) {
        if (this.fields[field]) {
          return true
        }
      }
      return false
    },
    hasAnyOtherFieldValue: function(method) {
      if (this.isMethodGroup) {
        for (const m of this.method) {
          if (m !== method && this.hasFieldValue(m)) {
            return true
          }
        }
        return false
      }
    },
    showMethod: function(method) {
      return !this.hasAnyOtherFieldValue(method)
    },
    updateData: function(field, val) {
      this.fields[field] = val
      this.$parent.updateData(field, val)

      if (field === 'country') {
        this.fields.state = ''
        this.fields.zip = ''
      }
    },
    getStates() {
      return getCountryStates(this.fields.country, this.campaign.blacklisted_states)
    },
    isUsOrCA() {
      return isCountryUSOrCA(this.fields.country)
    },
    zipFormat(value) {
      return formatZipField(value, this.fields.country)
    },
    onHelpFocus(event) {
      event.stopPropagation()
      this.showHelp = true
    },
    onHelpBlur(event) {
      event.stopPropagation()
      this.showHelp = false
    },
    getHelpText(fieldName) {
      return VerificationFieldsHelpText[fieldName] || ''
    }
  }
}
</script>

<style scoped>
.help-icon {
  position: relative;
  margin-left: 5px;
  cursor: pointer;
  display: inline-block;
}

.help-icon svg {
  margin-top: -1px;
}

.help-popup {
  position: absolute;
  top: -45px;
  left: 0%;
  z-index: 10;
  background: #fff;
  border: 1px solid #ccc;
  padding: 8px;
  margin-top: 4px;
  font-size: 0.85em;
  width: max-content;
  box-shadow: 0 2px 5px rgba(0,0,0,0.15);
  border-radius: 4px;
}

.help-popup-mobile {
  margin-bottom: 10px;
  display: none;
  font-size: 12px;
}

@media screen and (max-width: 425px) {
  .help-popup {
    display: none;
  }

  .help-popup-mobile {
    display: inline-block;
  }

  .help-icon {
    margin-right: 5px;
  }

  label {
    margin-bottom: 5px;
  }
}
</style>
